<template>
  <!-- 虚拟仿真实验 -->
  <div class="item_contain">
    <!-- <div class="section-title">
      <span>虚拟仿真实验</span>
    </div> -->
    <div class="vr-margin">
      <div class="intro-title">
        <el-image :src="courseImg" class="title-icon" />
        <div class="title-text"><span>虚拟仿真实验</span></div>
      </div>
      <template v-if="datalist && datalist.length > 0">
        <div class="vr-list">
          <div class="item" v-for="(item, index) in datalist" :key="index">
            <div class="item_top">
              <div class="left-image">
                <el-image class="elimage" :src="item.cover ? item.cover : image09" />
              </div>
              <div class="right-content">
                <div class="content-title">{{ item.name }}</div>
                <div class="intro-title">
                  <div class="people-num">
                    <div class="people-left">
                      <el-image class="elimage" :src="icon1" />
                      <div class="num">已参与人次:</div>
                      <div class="num">{{ item.join_count }}</div>
                    </div>
                    <div class="relatedchapters">
                      <div class="left">
                        <el-image class="elimage" :src="icon2" />
                        <div class="num">
                          关联章节：
                          <span class="bt_text" @click="tomore(item)">查看</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="enterbt">
                    <div class="bt" @click="tourl(item)">进入实验</div>
                  </div>
                </div>
              </div>

            </div>
            <!-- <div class="line"></div> -->
          </div>
        </div>
      </template>
      <template v-else>
        <div class="is-empty" style="text-align: center">
          <img :src="no_math" />
          <div style="
            font-size: 18px;
            color: #b5a2a2;
            margin-bottom: 30px;
            text-align: center;
          ">
            <span>暂无关联实验</span>
          </div>
        </div>
      </template>
      <Customdialog ref="customdialog" :showclose="true" title="关联章节" width="40%" type="table" class="customdialog">
        <div slot="dialogbody" class="dialogbody">
          <Outlinetable ref="outlinetable"></Outlinetable>
        </div>
      </Customdialog>
    </div>
  </div>
</template>
<script>
import {
  getVRList,
  getVRModuleList,
  getvrmodulelink,
  getCourseVrModuleList,
} from "@/api/vr";
import { getToken } from "@/utils/auth";
import Customdialog from "@/components/customdialog.vue";
import Outlinetable from "./outlinetable";

export default {
  name: "Courseintroduction",
  components: { Customdialog, Outlinetable },
  data() {
    return {
      token: getToken() ? true : false,
      courseKey: "",
      datalist: [],
      testimage: require("@/assets/test.png"),
      icon1: require("@/assets/course/UIout/VR/VR_ico_01_hover.png"),
      icon2: require("@/assets/coursedetails/矢量智能对象 (1).png"),
      no_math: require("@/assets/no_math1.png"),
      model_list_id: "",
      courseImg: require("@/assets/course/UIout/VR/VR_decor_ico_01.png"),
      image09: require("@/assets/vr.png"),
    };
  },
  methods: {
    initdata(obj, courseKey) {
      console.log("虚拟仿真实验", obj, courseKey);
      if (courseKey) {
        this.courseKey = courseKey;
        this.getVrModuleList({ course_semester_sn: courseKey });
      }
    },
    tomore(item) {
      this.$refs.customdialog.dialogopenbt();
      this.$nextTick(() => {
        this.$refs.outlinetable.initdata(this.courseKey, item.vr_id,);
      });
    },
    canclebt() {
      this.$refs.customdialog.dialogclosebt();
    },
    submitbt() {
      this.$refs.customdialog.dialogclosebt();
    },
    tourl(item) {
      if (item.id !== "") {
        if (this.token) {
          let params = { id: item.id };
          getvrmodulelink(params).then((response) => {
            if (response.data) {
              window.open(response.data.url, "_blank");
            }
          });
        } else {
          this.$confirm("请先登录!", "登录提示", {
            confirmButtonText: "去登录",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$router.push({
                path: "/login",
              });
            })
            .catch(() => { });
        }
      }
    },
    getVrModuleList(params) {
      getCourseVrModuleList(params)
        .then((res) => {
          this.datalist = res.data;
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.item_contain {
  // padding: 10px;
  // min-height: 400px;
  // width: calc(100% - 20px);
  // overflow-y: auto;
  background: #FFFFFF;
  box-shadow: 0px 2px 8px 0px rgba(128, 112, 250, 0.1);
  border-radius: 12px 12px 12px 12px;

  .vr-margin {
    margin-top: 10px;
    width: 100%;
    position: relative;
    min-height: 400px;
    background: url(~@/assets/course/UIout/VR/AR_decor_02.png) no-repeat;
    background-position: right bottom;
    // box-shadow: 0px 2px 8px 0px rgba(128, 112, 250, 0.1);
    padding: 20px;
    box-sizing: border-box;

    .vr-list {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      gap: 10px;
      margin-top: 20px;
    }
  }

  .intro-title {
    display: flex;
    align-items: center;
    gap: 10px;

    .title-icon {
      position: absolute;
    }

    .title-text {
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;
      position: relative;
      left: 6%;
      top: -5px;
    }

    i {
      margin-right: 8px;
      color: #7b5cff;
      font-size: 20px;
    }
  }

  .item {

    width: calc(25% - 10px);

    .item_top {
      box-shadow: 0px 2px 10px 0px rgba(128, 112, 250, 0.19);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid;
      border-image: linear-gradient(180deg, rgba(128, 112, 250, 0.15), rgba(255, 255, 255, 1)) 1 1;

      // display: flex;
      // justify-content: flex-start;
      // align-items: center;

      .left-image {
        // margin-left: 20px;

        // height: 140px;
        border-radius: 4px;

        .elimage {
          // width: 240px;
          // height: 140px;
          border-radius: 5px;
        }
      }

      .right-content {
        // background: url(~@/assets/course/UIout/VR/VR_cardbgn_hover.png) no-repeat;
        // background-size: 100% 100%;
        // height: 140px;
        margin-left: 20px;
        padding-top: 20px;
        // width: 60%;

        .content-title {
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .intro-title {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;

          .title-item {
            margin-right: 10px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .item-text {
              margin-right: 10px;
              font-size: 16px;
              font-weight: 400;
              color: #666666;
            }
          }
        }

        .people-num {

          .people-left {
            margin-top: 10px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 10px;
          }

          .num {
            font-weight: 500;
            font-size: 14px;
            color: #AAAAAA;
            line-height: 26px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .relatedchapters {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;


          .left {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 10px;

            .elimage {
              width: 18px;
              height: 15px;
            }

            .num {
              font-weight: 500;
              font-size: 14px;
              color: #AAAAAA;
              line-height: 26px;
              text-align: left;
              font-style: normal;
              text-transform: none;

              .bt_text {
                font-size: 16px;
                cursor: pointer;
                font-weight: 400;
                color: #3d84ff;
              }
            }
          }

          .moretext {
            margin-left: 20px;
            font-size: 16px;
            font-weight: 400;
            color: #3d84ff;
            user-select: none;
            cursor: pointer;
          }
        }
      }
    }

    .enterbt {
      // margin-top: 60px;
      // display: flex;
      // justify-content: flex-end;
      // align-items: center;
      margin-right: 20px;

      .bt {
        width: 88px;
        height: 32px;
        background: #8070FA;
        border-radius: 20px 20px 20px 20px;
        border: 1px solid #FFFFFF;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 32px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        cursor: pointer;
      }
    }

    .line {
      margin-left: 20px;
      border-bottom: 1px solid #ebeef5;
    }
  }

  .customdialog {
    .dialogbody {
      padding: 10px;

      .item {
        margin-top: 20px;

        .item-title {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .item-title-text {
            margin-right: 30px;
            font-size: 20px;

            font-weight: bold;
            color: #666666;
          }
        }

        .item-item {
          margin-top: 20px;
          margin-left: 70px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .item-item-icon {
            width: 12px;
            height: 12px;
            background: #c6c6d3;
            border-radius: 50%;
          }

          .item-item-num {
            margin-right: 10px;
            margin-left: 10px;
            font-size: 18px;

            font-weight: 400;
            color: #666666;
          }

          .item-item-text {
            font-size: 18px;

            font-weight: 400;
            color: #666666;
          }
        }
      }
    }

    .dialogfooter {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 100px;

      .bt {
        margin-right: 10px;
        width: 64px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #7f7f7f;
        border-radius: 4px;
        user-select: none;
        cursor: pointer;
        font-size: 15px;

        font-weight: 400;
        color: #222222;
      }

      .btactive {
        background: #3d84ff;
        border: 1px solid #3d84ff;
        color: white;
      }
    }
  }
}

/* 响应式 */
@media screen and (max-width: 1200px) {
  .item_contain {
    .vr-margin {
      .item {
        width: 33.33%;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .item_contain {
    .vr-margin {
      padding: 12px;
      min-height: auto;

      .intro-title {
        .title-text {
          font-size: 16px;
        }
      }

      .item {
        width: 50%;

        .item_top {
          .right-content {
            padding-top: 12px;
            margin-left: 12px;

            .content-title {
              font-size: 15px;
            }

            .intro-title {
              .title-item {
                .item-text {
                  font-size: 14px;
                }
              }
            }

            .people-num {
              .num {
                font-size: 13px;
              }
            }

            .relatedchapters {
              .left {
                .num {
                  font-size: 13px;

                  .bt_text {
                    font-size: 14px;
                  }
                }
              }

              .moretext {
                font-size: 14px;
              }
            }
          }
        }

        .enterbt {
          margin-right: 12px;

          .bt {
            width: 72px;
            height: 28px;
            line-height: 28px;
            font-size: 13px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .item_contain {
    .vr-margin {
      padding: 10px;

      .intro-title {
        .title-text {
          font-size: 15px;
        }
      }

      .item {
        width: 100%;

        .item_top {
          .right-content {
            padding-top: 10px;
            margin-left: 10px;

            .content-title {
              font-size: 14px;
            }

            .intro-title {
              flex-direction: column;
              align-items: flex-start;
              gap: 6px;
            }

            .relatedchapters {
              flex-direction: column;
              align-items: flex-start;
              gap: 6px;

              .moretext {
                margin-left: 0;
              }
            }
          }
        }

        .enterbt {
          margin-right: 10px;

          .bt {
            width: 64px;
            height: 26px;
            line-height: 26px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
